import React, { useState } from "react"
import styled from "styled-components"
import { RulesData } from "../Lang/RulesData"
import { ReturnRules } from "../Lang/ReturnRules"
import MainLogo from '../assets/mainLogo.svg';
import BreadCromb from "../components/HomeComp/BreadCromb";


const Style=styled.div`
    position: relative;
    width: calc(100% - var(--width-padding));
    display: grid;
    grid-template-columns: 25% calc(75% - 1rem);
    grid-gap: 1rem;
    padding:0 var(--padding);
    .braedcromb{
        margin:  calc(var(--padding-top) + 20px) 0 0;
        grid-column: span 2;
    }
    .rules-title{
        position: sticky;
        top: 130px;
        padding: 0 2rem ;
        display: flex;
        flex-direction: column;
        align-items:flex-start ;
        line-height: 2rem;
        height: min-content;
        .list{
            color: var(--text-2);
            list-style-type: square ;
            font-weight: 300;
            font-size: var(--fs-rule);
            cursor: pointer;
        }
        .active{
            color: var(--primary-1);
            font-weight: 500;
        }
    }
    .show-rules{
        display: flex;
        flex-direction: column;
        border-radius: var(--border-radius-2);
        background-color: var(--body-2);
        padding:2rem ;
        width: calc(100% - 4rem);
        min-height: 10rem;
        ::-webkit-scrollbar-track {
            border-radius: 10px;
        }
        ::-webkit-scrollbar {
            margin: 1rem 0;
            width: 5px;
            height: 3px;
            background-color: var(--body-2);
        }
        ::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background-color: var(--primary-1);
        }
    }
    .logo{
        width: 100% ;
        opacity: 0.5;
        margin: 10rem 0;
    }
    @media screen and (max-width: 850px) {
        display: flex;
        flex-direction: column;
        grid-gap: 0;
        margin:0;
        padding: 0 1rem;
        width: calc(100% - 2rem);
        min-height: 50vh;
        overflow-y: hidden;
        position: sticky;
        top: 60px;
        .braedcromb{
            margin:  120px 0 0;
            grid-column: span 2;
        }
        .rules-title{
            width: max-content;
            top: 0;
            padding:0 var(--padding);
        }
        .show-rules{
            padding: 0.5rem;
            width: calc(100% - 1rem);
            max-height: 60vh;
            margin-bottom: 1rem;
            overflow-y: scroll ;
        }
        .logo-show{
            margin: 2rem 0;
            max-height: 100vh ;
            .logo{
                justify-content: center;
                display: flex;
                margin: 0;
    
            }
        }
    }
`
const ReturnRuleStyle =styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin:1rem 0 ;
    .rule-desc{
        display: flex;
        flex-direction: column;
        padding:0 1rem;
        width: calc(100% -2rem);
        font-size: 14px;
        font-weight: 500;
        line-height: 2.5rem;
        .baseTitle{
            display: flex;
            justify-content: center;
            text-align: center;
            font-weight: 800;
            font-size: var(--fs-rule-header);
            margin-bottom: 1rem;
            white-space: pre-wrap;
        }
        .baseText ,.alertText{
            text-align:justify ;
            display: flex;
            white-space: pre-wrap;
            font-size: var(--fs-rule-text);
        }
        .alertText{
            ::before{
                content: '-';
                width: 20px;
                margin-left: 5px;
                color:var(--text-2)
            }
        }
        .rule{
            .r-title, .r-sub-title{
                font-weight: 600;
                margin: 2rem 0 1rem;
                color: var(--primary-2);
                font-size: var(--fs-rule-text);
            }
            .r-text{
                display: flex;
                text-align:justify ;
                white-space: pre-wrap;
                font-size: var(--fs-rule-text);
            }
            .r-reason{
                .r-reason-title{
                    font-weight: 500;
                    color: var(--primary-2);
                    font-size: var(--fs-rule-text);
                }
                ul {
                    .r-reason-list-item{
                        list-style-type:square ;
                        white-space: pre-wrap;
                        text-align:justify ;
                    }
                    .b-item{
                        list-style-type:circle ;
                        white-space: pre-wrap;
                        text-align:justify ;
                    }
                }
            }
        }
    }
`

const ServiceRule =styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin:1rem 0 ;
    .rule-desc{
        display: flex;
        flex-direction: column;
        padding:0 1rem;
        width: calc(100% -2rem);
        font-size: 14px;
        font-weight: 500;
        line-height: 2.5rem;
        .baseTitle{
            text-align:justify ;
            font-weight: 800;
            font-size: var(--fs-rule-header);
            margin-bottom: 1rem;
        }
        .baseText {
            text-align:justify ;
            font-size: var(--fs-rule-text);
            white-space: pre-wrap;

        }
        .rule{
            .r-title, .r-sub-title{
                font-weight: 600;
                margin: 2rem 0 1rem;
                color: var(--primary-2);
                font-size: var(--fs-rule-text);

            }
            .r-sub-list{
                .r-sub-list-item{
                    white-space: pre-wrap;
                    text-align:justify ;
                    font-size: var(--fs-rule-text);
                }
            }
            .r-text , .r-sub-text{
                white-space: pre-wrap;
                text-align:justify ;
                font-size: var(--fs-rule-text);
            }
            .r-reason{
                font-weight: 800;
                font-size: var(--fs-rule-text);
            }
        }
    }
`

const Rules =()=>{
    const [show,setShow] = useState(0)
    const [ rules ]= useState([
        {id: 0 ,name:'شرایط و قوانین استفاده از سرویس'},
        {id: 1 ,name:'رویه بازگرداندن کالا'}
    ])
    window.scrollTo({
        top:0,
        left:0,
        behavior: "smooth"
    })
    const openRoules=(index ,value)=>{
        if(parseInt(value.id) === parseInt(index)){
            window.scrollTo({
                top:0,
                left:0,
                behavior: "smooth"
            })
            setShow(value.id)
        }else{
            window.scrollTo({
                top:0,
                left:0,
                behavior: "smooth"
            })
            setShow(-1)
        }
    }
    const rulesShow=()=>{
        if(show === 0){
            return(
                <ServiceRule>
                    <div className="rule-desc">
                        <div className="baseTitle">
                            {RulesData.data.baseTitle}
                        </div>
                        <pre className="baseText">
                            {RulesData.data.baseText}
                        </pre>  
                            {
                                RulesData.data.allTitles.map((value,index)=>{
                                    return(
                                        <div key={index} className='rule'>
                                            <span className='r-title'>
                                                {value.title}
                                            </span>
                                            <pre className='r-text'>
                                                {value.textTitle}
                                            </pre>
                                            {
                                                value.listT ?(
                                                    <ul className='r-list' >
                                                    { (value.listT).map((val)=>{
                                                        return(
                                                            <li key={val.id} className='r-list-item'>{val.text}</li>
                                                        ) 
                                                        })}
                                                    </ul>
                                                )
                                                :''
                                            }
                                        </div>
                                    )
                                })   
                            }
                            {
                                 RulesData.data.allSubjects.map((value,index)=>{
                                    return(
                                        <div key={index} className='rule'>
                                            <span className='r-sub-title'>
                                                {value.sub}
                                            </span>
                                            <pre className='r-sub-text'>
                                                {value.subText}
                                            </pre>
                                            {
                                                value.subList ?(
                                                    <ul className='r-sub-list'>
                                                    { (value.subList).map((val)=>{
                                                        return(
                                                            <li key={val.id} className='r-sub-list-item'>{val.text}</li>
                                                        ) 
                                                        })}
                                                    </ul>
                                                )
                                                :''
                                            }
                                            {
                                                value.subText2 ? (
                                                    <pre className='r-sub-text'>
                                                        {value.subText2}
                                                    </pre>
                                                )
                                                :''
                                            }
                                        </div>
                                    )
                                })   
                            }
                    </div>
                </ServiceRule>
            )
        }else if(show === 1){
            return (
                <ReturnRuleStyle>
                    <div className="rule-desc">
                        <div className="baseTitle">
                            {ReturnRules.data.baseTitle}
                        </div>
                        <pre className="baseText">
                            {ReturnRules.data.baseText}
                        </pre>
                        <pre className="alertText">
                            {ReturnRules.data.alert}
                        </pre>
                        {
                            ReturnRules.data.allTitles.map((value,index)=>{
                                return(
                                    <div key={index} className='rule'>
                                        <span className='r-title'>
                                            {value.title}
                                        </span>
                                        <pre className='r-text'>
                                            {value.textTitle}
                                        </pre>
                                        {
                                            value.reason ? (
                                                value.reason.map((val,ind)=>{
                                                return (
                                                    <div className='r-reason' key={ind}>
                                                        {val.title ? (<span className="r-reason-title">{val.title}</span>) : ''}
                                                        {
                                                            val.listB ?
                                                            (
                                                                <ul className="r-reason-list">
                                                                    {
                                                                        val.listB.map((res)=>
                                                                            <li key={res.id} className="r-reason-list-item b-item">
                                                                                {res.text}
                                                                            </li>
                                                                        )
                                                                    }
                                                                </ul>
                                                            )
                                                            :''
                                                        }
                                                        {
                                                            val.listT ?
                                                            (
                                                                <ul className="r-reason-list">
                                                                    {
                                                                        val.listT.map((res)=>
                                                                            <li key={res.id} className="r-reason-list-item">
                                                                                {res.text}
                                                                            </li>
                                                                        )
                                                                    }
                                                                </ul>
                                                            )
                                                            :''
                                                        }
                                                    </div>
                                                )
                                                
                                                })
                                            )
                                            :''
                                        }
                                        
                                        {
                                            value.lastText ?(
                                                <pre className='r-text'>
                                                    {value.lastText}
                                                </pre>
                                            ):''
                                        }
                                    </div>
                                )
                            })   
                        }
                    </div>
                </ReturnRuleStyle>
            )
        }else{
            return  <img className="logo" src={MainLogo} alt="Luxinlux"/>
        }
    }
    let braedcromb= [{name: 'خانه', link: '/'},{name: 'شرایط و قوانین', link: '/rules/'} ]
    return(
        <Style>
            <div className="braedcromb">
                <BreadCromb data={braedcromb} classname={'without-margin'}/>
            </div>
            <ul className="rules-title">
                {rules.map((value,index)=>{
                    return(
                        <li key={index} 
                        className={'list ' + ( show === value.id ? 'active' : '' )}
                        onClick={()=> openRoules(index,value)}>
                            {value.name}
                        </li>
                    )
                })}
            </ul>
            <div className={(show !== -1) ? "show-rules" :'logo-show'}>
                {rulesShow()}
            </div>
        </Style>
    )
}
export default Rules